/* GCS Schnellkauf (Baustein 6, global, defer). Ersetzt den Stub aus Baustein 1.
   Klick auf [data-gcs-quick-add] (Event-Delegation am document, auch für nachgeladene Karten):
     - mit data-variant-id: GCS.cart.add([{ id, quantity: 1 }], { source: 'card' }), bei data-variant-preorder
       zusätzlich properties { Typ: 'Vorbestellung' }
     - ohne: Sheet (mobil unten, Desktop kleines Panel) mit Inhalt aus der Section Rendering API im Produktkontext:
       /products/<handle>?section_id=gcs-quick-add-sheet (Preise und Vorbestellung kommen aus Liquid).
       „In den Warenkorb“ / „Vorbestellen“ → GCS.cart.add(…, { source: 'quick-add' }), danach schließt das Sheet
       (der Warenkorb öffnet sich über GCS.cart.add).
   API: GCS.quickAdd.open(buttonOderUrl), GCS.quickAdd.close(), GCS.quickAdd.prefetch(url).
   Impeccable C3 (02.10.2026): Anzahl als Pack-Kacheln 1–4 (Staffel aus den Theme-Settings, Preise nur Anzeige wie
   auf der PDP) oder Stepper (ausgenommene Produkte, Bundles); die Menge geht als quantity an GCS.cart.add.
   „Größe wählen“ bleibt aktiv und führt zur fehlenden Größe (Hinweis, Markierung, Fokus) wie die PDP.
   Vorbestellung (Abschluss Impeccable, 02.10.2026): Live schreibt die App „Preorder Now Wolf“ bei Vorbestellungs-
   Varianten properties[Typ]=Vorbestellung ins Produktformular (Fulfillment-Kennzeichnung, kein Selling Plan); die PDP
   schickt das seit a5ca46e mit. Sheet und Karte haben kein App-Formular, deshalb setzen wir die Eigenschaft selbst,
   wenn die Variante nach Bauvertrag 4 Vorbestellung ist (Flag „preorder“ aus dem Section-JSON bzw. data-variant-preorder
   an der Karte). GCS.quickAdd.variants(url) liefert dieselben Liquid-Flags für die Empfehlungen im Warenkorb. */
(() => {
  const GCS = (window.GCS = window.GCS || {});
  if (GCS.quickAdd && !GCS.quickAdd.__stub) return;
  if (GCS.quickAdd && GCS.quickAdd.handle) document.removeEventListener('click', GCS.quickAdd.handle);

  const SECTION = 'gcs-quick-add-sheet';
  const ERROR = 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
  /* Exakt Schlüssel und Wert wie live (Preorder Now Wolf), gleiche Konstante in gcs-cart.js */
  const PREORDER_PROPERTIES = { Typ: 'Vorbestellung' };
  const cartItem = (id, quantity, preorder) => {
    const item = { id, quantity };
    if (preorder) item.properties = Object.assign({}, PREORDER_PROPERTIES);
    return item;
  };
  const cache = new Map();
  let sheet = null;
  let token = 0;
  let current = null;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = (cents) =>
    typeof GCS.formatMoney === 'function' ? GCS.formatMoney(cents) : (cents / 100).toFixed(2).replace('.', ',') + ' €';
  const esc = (text) =>
    String(text).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  const productUrl = (button) => {
    if (button.dataset.productUrl) return button.dataset.productUrl;
    return root() + 'products/' + encodeURIComponent(button.dataset.productHandle || '');
  };

  /* Suchtreffer-URLs tragen _pos/_sid/_ss: für die Section nur den Pfad verwenden */
  const sectionUrl = (url) => {
    const target = new URL(url, window.location.origin);
    return target.pathname + '?section_id=' + SECTION;
  };

  const load = (url) => {
    const key = sectionUrl(url);
    if (!cache.has(key)) {
      const request = fetch(key, { headers: { Accept: 'text/html' } })
        .then((response) => {
          if (!response.ok) throw new Error(String(response.status));
          return response.text();
        })
        .catch((error) => {
          cache.delete(key);
          throw error;
        });
      cache.set(key, request);
    }
    return cache.get(key);
  };

  /* Section-HTML → Inhalt + Daten (Varianten mit Liquid-Flags available/preorder) */
  const parse = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const content = doc.querySelector('[data-gcs-qa]');
    const dataEl = content && content.querySelector('[data-gcs-qa-data]');
    if (!content || !dataEl) throw new Error('empty');
    return { content, data: JSON.parse(dataEl.textContent) };
  };

  const closeIcon =
    '<svg class="gcs-icon" width="22" height="22" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 6 12 12M18 6 6 18"/></svg>';

  const ensureSheet = () => {
    if (sheet && document.body.contains(sheet)) return sheet;
    sheet = document.createElement('gcs-drawer');
    sheet.id = 'GcsQuickAdd';
    sheet.className = 'gcs-drawer gcs-drawer--bottom gcs-qa-drawer';
    sheet.innerHTML =
      '<div class="gcs-drawer__overlay" data-gcs-close></div>' +
      '<div class="gcs-drawer__panel gcs-scheme--cream" role="dialog" aria-modal="true" aria-labelledby="GcsQuickAddTitle" tabindex="-1">' +
      '<div class="gcs-drawer__head"><p class="gcs-drawer__title" id="GcsQuickAddTitle">Größe wählen</p>' +
      '<button type="button" class="gcs-iconbtn" data-gcs-close aria-label="Schließen">' +
      closeIcon +
      '</button></div>' +
      '<div class="gcs-drawer__body" data-gcs-qa-slot="body"></div>' +
      '<div class="gcs-drawer__foot" data-gcs-qa-slot="foot" hidden></div>' +
      '</div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('gcs:drawer:close', () => {
      token += 1;
      current = null;
    });
    return sheet;
  };

  const slots = () => ({
    title: sheet.querySelector('#GcsQuickAddTitle'),
    body: sheet.querySelector('[data-gcs-qa-slot="body"]'),
    foot: sheet.querySelector('[data-gcs-qa-slot="foot"]'),
    panel: sheet.querySelector('.gcs-drawer__panel'),
  });

  const renderLoading = () => {
    const { body, foot, title, panel } = slots();
    title.textContent = 'Größe wählen';
    foot.hidden = true;
    foot.innerHTML = '';
    panel.setAttribute('aria-busy', 'true');
    const tile = '<div class="gcs-skeleton" style="height:52px"></div>';
    body.innerHTML =
      '<div aria-hidden="true">' +
      '<div style="display:grid;grid-template-columns:88px minmax(0,1fr);gap:14px;align-items:center;padding-bottom:16px">' +
      '<div class="gcs-skeleton gcs-skeleton--img"></div>' +
      '<div><div class="gcs-skeleton gcs-skeleton--text" style="width:70%;height:20px"></div>' +
      '<div class="gcs-skeleton gcs-skeleton--text" style="width:45%"></div>' +
      '<div class="gcs-skeleton gcs-skeleton--text" style="width:30%"></div></div></div>' +
      '<div class="gcs-skeleton gcs-skeleton--text" style="width:60px;margin:16px 0 10px"></div>' +
      '<div class="gcs-tiles">' +
      tile +
      tile +
      tile +
      tile +
      '</div></div>' +
      '<p class="gcs-sr" role="status">Größen werden geladen</p>';
  };

  const renderError = (url) => {
    const { body, foot, panel } = slots();
    panel.removeAttribute('aria-busy');
    foot.hidden = true;
    body.innerHTML =
      '<div class="gcs-stack" role="alert">' +
      '<p class="gcs-text">Die Größen konnten nicht geladen werden.</p>' +
      '<div class="gcs-cluster">' +
      '<button type="button" class="gcs-btn gcs-btn--s" data-gcs-qa-retry>Erneut versuchen</button>' +
      '<a class="gcs-link" href="' +
      esc(url) +
      '">Zum Produkt</a>' +
      '</div></div>';
    const retry = body.querySelector('[data-gcs-qa-retry]');
    if (retry) retry.addEventListener('click', () => show(url, sheet.opener));
  };

  /* Steuerung einer geladenen Auswahl ------------------------------------- */
  class Picker {
    constructor(content, data) {
      this.body = slots().body;
      this.foot = slots().foot;
      this.data = data;
      this.variants = data.variants || [];
      this.form = this.body.querySelector('[data-gcs-qa-form]');
      this.groups = Array.from(this.body.querySelectorAll('[data-gcs-qa-option]')).map((el) => ({
        el,
        index: Number(el.dataset.gcsQaOption),
        inputs: Array.from(el.querySelectorAll('input[type="radio"]')),
        chosen: el.querySelector('[data-gcs-qa-chosen]'),
        hint: el.querySelector('[data-gcs-qa-hint]'),
      }));
      this.packs = Array.from(this.body.querySelectorAll('[data-gcs-qa-packs] input[type="radio"]'));
      this.qtyInput = this.body.querySelector('[data-gcs-qa-qty]');
      this.submit = this.foot.querySelector('[data-gcs-qa-submit]');
      this.label = this.foot.querySelector('[data-gcs-qa-label]');
      this.btnPrice = this.foot.querySelector('[data-gcs-qa-btn-price]');
      this.note = this.foot.querySelector('[data-gcs-qa-note]');
      this.error = this.body.querySelector('[data-gcs-qa-error]');
      this.idInput = this.body.querySelector('[data-gcs-qa-id]');
      this.price = this.body.querySelector('[data-gcs-qa-price]');
      this.variant = null;

      this.form.addEventListener('change', (event) => {
        this.hideError();
        const group = this.groups.find((g) => g.el.contains(event.target));
        if (group) this.clearAttention(group);
        if (event.target === this.qtyInput) this.clampQty();
        this.update();
      });
      this.form.addEventListener('click', (event) => {
        const step = event.target.closest('[data-gcs-qa-step]');
        if (!step || !this.qtyInput) return;
        event.preventDefault();
        this.qtyInput.value = String((Number(this.qtyInput.value) || 1) + Number(step.dataset.gcsQaStep));
        this.clampQty();
        this.update();
      });
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      this.update();
    }

    /* Menge: gewählte Pack-Kachel oder Stepper (1–99) */
    quantity() {
      const pack = this.packs.find((input) => input.checked);
      if (pack) return Number(pack.value) || 1;
      if (this.qtyInput) return Math.min(99, Math.max(1, Math.round(Number(this.qtyInput.value) || 1)));
      return 1;
    }

    clampQty() {
      if (!this.qtyInput) return;
      const qty = this.quantity();
      this.qtyInput.value = String(qty);
      const minus = this.form.querySelector('[data-gcs-qa-step="-1"]');
      const plus = this.form.querySelector('[data-gcs-qa-step="1"]');
      if (minus) minus.setAttribute('aria-disabled', qty <= 1 ? 'true' : 'false');
      if (plus) plus.setAttribute('aria-disabled', qty >= 99 ? 'true' : 'false');
    }

    /* Anzeige wie der Pack-Selector der PDP: Prozent pro Position, auf Cent gerundet. Abgezogen wird im Warenkorb. */
    packTotal(price, n) {
      const pct = Number((this.data.tiers || {})[n]) || 0;
      const line = price * n;
      return line - Math.round((line * pct) / 100);
    }

    lineTotal(price) {
      const qty = this.quantity();
      if (this.packs.length) return this.packTotal(price, qty);
      return price * qty;
    }

    updatePacks(price) {
      const pairs = Number(this.data.packPairs) || 2;
      this.packs.forEach((input) => {
        const n = Number(input.value) || 1;
        const pp = input.closest('.gcs-qa-pack') && input.closest('.gcs-qa-pack').querySelector('[data-gcs-qa-pack-pp]');
        if (pp) pp.textContent = money(Math.round(this.packTotal(price, n) / (pairs * n)));
      });
    }

    selection() {
      return this.groups.map((group) => {
        const checked = group.inputs.find((input) => input.checked);
        return checked ? checked.value : null;
      });
    }

    update() {
      const sel = this.selection();
      const showPre = this.data.showPreLabels !== false;
      this.groups.forEach((group, gi) => {
        group.inputs.forEach((input) => {
          const tile = input.closest('.gcs-tile');
          const sub = tile && tile.querySelector('[data-gcs-qa-sub]');
          const candidates = this.variants.filter(
            (v) => v.options[gi] === input.value && v.options.every((o, j) => j === gi || sel[j] === null || o === sel[j])
          );
          const exists = candidates.length > 0;
          const available = candidates.filter((v) => v.available);
          const soldout = exists && available.length === 0;
          const preorder = available.length > 0 && available.every((v) => v.preorder);
          input.disabled = !exists;
          if (tile) {
            tile.classList.toggle('is-unavailable', soldout);
            tile.classList.toggle('is-preorder', preorder && showPre);
          }
          if (sub) sub.innerHTML = soldout ? 'Ausverkauft' : preorder && showPre ? 'Vor&shy;bestellung' : '';
        });
        const checked = group.inputs.find((input) => input.checked);
        if (group.chosen) group.chosen.textContent = checked ? checked.dataset.label || checked.value : '';
      });

      const complete = sel.every((value) => value !== null);
      this.variant = complete
        ? this.variants.find((v) => v.options.every((o, i) => o === sel[i])) || null
        : null;
      const v = this.variant;
      if (this.idInput) this.idInput.value = v ? v.id : '';

      if (!complete) {
        const missing = this.missingGroup();
        const name = (missing && missing.el.dataset.short) || 'Größe';
        this.setButton(`${name} wählen`, false, '');
        const open = this.variants.filter((variant) => variant.available);
        const allPreorder = open.length > 0 && open.every((variant) => variant.preorder);
        this.setNote(allPreorder ? this.data.preorderText : this.data.deliveryText, allPreorder);
      } else if (!v || !v.available) {
        this.setButton('Ausverkauft', true, '');
        this.setNote('Diese Auswahl ist gerade ausverkauft.', false);
      } else if (v.preorder) {
        this.setButton('Vorbestellen', false, money(this.lineTotal(v.price)));
        this.setNote(this.data.preorderText, true);
      } else {
        this.setButton('In den Warenkorb', false, money(this.lineTotal(v.price)));
        this.setNote(this.data.deliveryText, false);
      }
      const base = v || this.variants.find((variant) => variant.available) || this.variants[0];
      if (base) this.updatePacks(base.price);
      if (v) this.updatePrice(v);
    }

    missingGroup() {
      return this.groups.find((group) => !group.inputs.some((input) => input.checked)) || null;
    }

    /* „Größe wählen“ getippt: Gruppe markieren, Hinweis zeigen, Fokus auf die erste wählbare Größe */
    promptSelection() {
      const group = this.missingGroup();
      if (!group) return;
      const name = group.el.dataset.name || 'Größe';
      if (group.hint) {
        group.hint.textContent = String(this.data.hint || 'Bitte wähl deine [name].').replace('[name]', name);
        group.hint.hidden = false;
      }
      group.el.classList.remove('is-attention');
      void group.el.offsetWidth;
      group.el.classList.add('is-attention');
      const first = group.inputs.find((input) => !input.disabled);
      if (first) first.focus();
    }

    clearAttention(group) {
      group.el.classList.remove('is-attention');
      if (group.hint) {
        group.hint.hidden = true;
        group.hint.textContent = '';
      }
    }

    setButton(text, disabled, price) {
      if (this.label) this.label.textContent = text;
      if (this.btnPrice) this.btnPrice.textContent = price;
      if (this.submit) this.submit.disabled = disabled;
    }

    setNote(text, preorder) {
      if (!this.note) return;
      this.note.textContent = text || '';
      this.note.classList.toggle('is-preorder', !!preorder);
      this.note.hidden = !text;
    }

    updatePrice(v) {
      if (!this.price) return;
      const now = this.price.querySelector('[data-gcs-price-now]');
      const was = this.price.querySelector('[data-gcs-price-was]');
      const pp = this.price.querySelector('[data-gcs-price-pp]');
      if (now) now.textContent = money(v.price);
      if (was) {
        was.hidden = !(v.compare > v.price);
        if (v.compare > v.price) was.textContent = money(v.compare);
      }
      const pairs = Number(this.data.pairs) || (pp && Number(pp.dataset.pairs)) || 0;
      if (pp && pairs > 0) pp.textContent = `${money(Math.round(v.price / pairs))} pro Paar`;
    }

    hideError() {
      if (this.error) {
        this.error.hidden = true;
        this.error.textContent = '';
      }
    }

    showError(message) {
      if (!this.error) return;
      this.error.textContent = message || ERROR;
      this.error.hidden = false;
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.missingGroup()) {
        this.promptSelection();
        return;
      }
      const v = this.variant;
      if (!v || !v.available || !this.submit || this.submit.getAttribute('aria-busy') === 'true') return;
      if (!GCS.cart || typeof GCS.cart.add !== 'function') {
        this.form.submit();
        return;
      }
      this.hideError();
      this.submit.setAttribute('aria-busy', 'true');
      try {
        await GCS.cart.add([cartItem(v.id, this.quantity(), v.preorder)], { source: 'quick-add' });
        if (sheet && sheet.isOpen) sheet.close();
      } catch (error) {
        this.showError(error && error.message);
      } finally {
        if (this.submit) this.submit.removeAttribute('aria-busy');
      }
    }
  }

  const render = (html) => {
    const { content, data } = parse(html);
    const { body, foot, title, panel } = slots();
    const style = content.querySelector('style');
    const bodyContent = content.querySelector('[data-gcs-qa-body]');
    const footContent = content.querySelector('[data-gcs-qa-foot]');
    title.textContent = content.dataset.title || 'Größe wählen';
    body.replaceChildren(...[style, bodyContent].filter(Boolean).map((el) => document.importNode(el, true)));
    foot.replaceChildren(document.importNode(footContent, true));
    foot.hidden = false;
    panel.removeAttribute('aria-busy');
    current = new Picker(content, data);

    /* Fokus auf die erste offene Auswahl, solange er noch auf dem Panel liegt */
    if (document.activeElement === panel || !panel.contains(document.activeElement)) {
      const group = current.groups.find((g) => !g.inputs.some((input) => input.checked)) || current.groups[0];
      const input = group && group.inputs.find((i) => !i.disabled);
      if (input) input.focus({ preventScroll: true });
      else if (current.submit && !current.submit.disabled) current.submit.focus({ preventScroll: true });
    }
  };

  const show = async (url, opener) => {
    if (!customElements.get('gcs-drawer')) {
      window.location.href = url;
      return;
    }
    const el = ensureSheet();
    const mine = ++token;
    renderLoading();
    if (!el.isOpen) el.open(opener);
    else el.opener = opener || el.opener;
    try {
      const html = await load(url);
      if (mine !== token) return;
      render(html);
    } catch (error) {
      if (mine !== token) return;
      renderError(url);
    }
  };

  /* Direkt in den Warenkorb (genau eine verfügbare Variante) ------------- */
  const addDirect = (button) => {
    const id = Number(button.dataset.variantId);
    const preorder = button.hasAttribute('data-variant-preorder');
    if (!GCS.cart || typeof GCS.cart.add !== 'function') {
      window.location.href = productUrl(button);
      return;
    }
    button.setAttribute('aria-busy', 'true');
    GCS.cart
      .add([cartItem(id, 1, preorder)], { source: 'card' })
      .catch((error) => {
        if (GCS.toast) GCS.toast((error && error.message) || ERROR, { type: 'error' });
      })
      .finally(() => button.removeAttribute('aria-busy'));
  };

  const handle = (event) => {
    const button = event.target.closest && event.target.closest('[data-gcs-quick-add]');
    if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();
    event.stopPropagation();
    if (button.dataset.variantId) addDirect(button);
    else show(productUrl(button), button);
  };

  /* Vorladen bei Maus-Hover oder Touch-Beginn, damit das Sheet sofort gefüllt ist */
  const prefetch = (event) => {
    const button = event.target.closest && event.target.closest('[data-gcs-quick-add]');
    if (!button || button.disabled || button.dataset.variantId) return;
    if (event.type === 'pointerover' && event.pointerType !== 'mouse') return;
    load(productUrl(button)).catch(() => {});
  };

  document.addEventListener('click', handle);
  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });

  GCS.quickAdd = {
    handle,
    prefetch: (url) => load(url).catch(() => {}),
    /* Varianten mit Liquid-Flags { id, options, available, preorder, … } → Promise<Array>; teilt den Cache mit dem Sheet */
    variants: (url) => load(url).then((html) => parse(html).data.variants || []),
    preorderProperties: () => Object.assign({}, PREORDER_PROPERTIES),
    open: (target) => {
      if (typeof target === 'string') return show(target, document.activeElement);
      if (target && target.nodeType === 1) return show(productUrl(target), target);
      return undefined;
    },
    close: () => {
      if (sheet && sheet.isOpen) sheet.close();
    },
  };
})();
